// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Authored HTN compact status grammar, shared by drug-toast previews and the
   live combat player rail. These component-owned kc-* classes deliberately do
   not inherit the unrelated bls-status-header chassis. */
.kc-tag {
  position: relative;
  display: inline-flex;
  align-items: center;
  outline: none;
  cursor: help;
  flex: 0 0 auto;
}

.kc-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 30px;
  min-height: 30px;
  padding: 0 9px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  color: rgba(255, 255, 255, 0.78);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.22px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  box-sizing: border-box;
  flex: 0 0 auto;
}

.kc-pill__icon {
  width: 15px;
  height: 15px;
  flex: 0 0 15px;
}

/* Potassium: bold blue K+ glyph + green-gradient monospace readout. */
.kc-pill--potassium {
  border-left: 2px solid rgba(96, 165, 250, 0.55);
}

.kc-pill--potassium .kc-kglyph {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  flex: 0 0 auto;
  font-family: var(--font-display, 'Outfit', system-ui, sans-serif);
  font-weight: 800;
  font-size: 15px;
  line-height: 1;
  letter-spacing: 0.01em;
  color: rgba(96, 165, 250, 0.95);
}

.kc-pill--potassium .kc-kglyph sup {
  font-size: 0.58em;
  font-weight: 800;
  line-height: 1;
  margin-left: 0.5px;
  vertical-align: top;
  position: relative;
  top: -0.15em;
}

.kc-readout {
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.01em;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  background: linear-gradient(100deg, #86efac, #4ade80);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}

.kc-readout__dash { margin: 0 3px; }

/* Banded potassium pill (Edward 2026-07-22): in combat the K+ status tag tints to
   the CURRENT band's tone — the SAME --effect-color the tooltip uses (hypo blue /
   balanced green / hyper red) — so the pill's colour matches the tooltip scheme at a
   glance. --kc-accent is set inline to model.tone. Scoped to .kc-pill--banded so the
   drug-toast PotassiumTag keeps its default blue-border / green-readout identity;
   the fallbacks reproduce that default if --kc-accent is ever unset. */
.kc-pill--potassium.kc-pill--banded {
  border-left-color: color-mix(in srgb, var(--kc-accent, rgb(96, 165, 250)) 55%, transparent);
}
.kc-pill--potassium.kc-pill--banded .kc-kglyph {
  color: var(--kc-accent, rgba(96, 165, 250, 0.95));
}
.kc-pill--potassium.kc-pill--banded .kc-readout {
  background: linear-gradient(
    100deg,
    color-mix(in srgb, var(--kc-accent, rgb(74, 222, 128)) 62%, #ffffff),
    var(--kc-accent, rgb(74, 222, 128))
  );
  -webkit-background-clip: text;
  background-clip: text;
}

/* HR: heartbeat glyph + rose-gradient readout. */
.kc-pill--hr {
  border-left: 2px solid rgba(251, 113, 133, 0.55);
}

.kc-pill--hr .kc-pill__icon { color: rgba(251, 113, 133, 0.95); }

.kc-pill--hr .kc-hrglyph {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-display, 'Outfit', system-ui, sans-serif);
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0.02em;
  background: linear-gradient(100deg, #fb7185, #f43f5e);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Heartbeat throb (Edward 2026-07-25): when the HR rail pill carries a nonzero
   pulse shift, its glyph BEATS at a rate set inline via --hr-beat-duration
   (tachycardia faster, bradycardia slower). A lub-dub systolic double-bump reads
   as a real heartbeat and stands in for the numeric readout. */
@keyframes kc-hr-beat {
  0%,
  100% { transform: scale(1); }
  12% { transform: scale(1.3); }
  24% { transform: scale(0.95); }
  36% { transform: scale(1.13); }
  52% { transform: scale(1); }
}

.kc-pill--hr-beating .kc-pill__icon {
  transform-origin: center;
  will-change: transform;
  animation: kc-hr-beat var(--hr-beat-duration, 850ms) ease-in-out infinite;
  filter: drop-shadow(0 0 3px rgba(251, 113, 133, 0.5));
}

@media (prefers-reduced-motion: reduce) {
  .kc-pill--hr-beating .kc-pill__icon { animation: none; }
}

/* Pending-mechanic suffix (2026-07-28) — the clock + rounds-remaining countdown a
   pill carries while its mechanic is drafted but not yet active. Teal
   rgb(45,212,191) is the canonical "this lands later" colour, shared with the
   delayed-damage tag, the \`round\`/\`rounds\` status word and GameTip's ClockIcon.
   It is deliberately NOT the pill's own rose: the countdown belongs to the delay,
   not to the mechanic waiting behind it. */
.kc-pill__suffix {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-left: 1px;
  color: rgb(45, 212, 191);
  font-weight: 800;
  font-size: 11px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
}

.kc-pill__suffix svg { width: 11px; height: 11px; }

/* A pulse that has not started yet does not throb and does not read rose. The
   glyph goes slate until the round it fires, so "armed" and "active" are
   distinguishable at a glance without reading the countdown. */
.kc-pill--hr.is-pending { border-left-color: rgba(45, 212, 191, 0.55); }
.kc-pill--hr.is-pending .kc-pill__icon { color: rgba(148, 163, 184, 0.9); }
.kc-pill--hr.is-pending .kc-hrglyph {
  background: linear-gradient(100deg, #cbd5e1, #94a3b8);
  -webkit-background-clip: text;
  background-clip: text;
}

/* Vasodilation (2026-07-28): blue, the colour this app already uses for "the
   incoming thing was negated" (the ADR-dodge absorb chip, 96,165,250). Vasodilation
   is exactly that primitive on the HTN board — a charge voids one whole pressure
   application — so it joins that family rather than inventing a sixth accent. It is
   deliberately NOT pressure's red: the tag is the answer to pressure, not a dose of
   it, and colouring it red would read as damage taken. */
.kc-pill--vasodilation {
  border-left: 2px solid rgba(96, 165, 250, 0.55);
}

.kc-pill--vasodilation .kc-pill__icon { color: rgba(96, 165, 250, 0.95); }

.kc-pill--vasodilation .kc-hrglyph {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-display, 'Outfit', system-ui, sans-serif);
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0.02em;
  background: linear-gradient(100deg, #93c5fd, #60a5fa);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* The charge count. Tabular so a 3 -> 2 -> 1 countdown does not reflow the pill. */
.kc-pill__count {
  display: inline-flex;
  align-items: center;
  margin-left: 2px;
  padding: 0 4px;
  border-radius: 4px;
  background: rgba(96, 165, 250, 0.16);
  color: rgb(147, 197, 253);
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
}

/* Spent. The pill stays on the rail rather than vanishing, because "you had this and
   it is gone" is information the player needs to read the round they just lost. */
.kc-pill--vasodilation.is-spent { opacity: 0.55; }
.kc-pill--vasodilation.is-spent .kc-pill__count {
  background: rgba(148, 163, 184, 0.16);
  color: rgba(148, 163, 184, 0.95);
}

/* Diuresis: teal droplet glyph + teal readout. */
.kc-pill--diuresis {
  border-left: 2px solid rgba(45, 212, 191, 0.55);
}

.kc-pill--diuresis .kc-pill__icon { color: rgba(45, 212, 191, 0.95); }

.kc-pill--diuresis .kc-hrglyph {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-primary, 'Hanken Grotesk', -apple-system, sans-serif);
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0.01em;
  text-transform: capitalize;
  font-variant-numeric: tabular-nums;
  color: #2dd4bf;
}

/* Potassium preview hover panel. The live rail keeps its existing
   CombatTooltip wrapper and therefore renders only PotassiumPill. */
.kc-panel {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 0;
  right: auto;
  z-index: 1000;
  width: max-content;
  max-width: min(320px, calc(100vw - 24px));
  padding: 0.72rem 0.9rem 0.72rem 1rem;
  background: #0b0e14;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(0, 0, 0, 0.4);
  opacity: 0;
  transform: translateY(4px);
  pointer-events: none;
  transition: opacity 140ms ease, transform 140ms ease;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  text-align: left;
  white-space: normal;
}

.kc-panel::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 2px;
  background: var(--effect-color, #f87171);
}

.kc-tag:hover .kc-panel,
.kc-tag:focus-within .kc-panel {
  opacity: 1;
  transform: none;
  pointer-events: auto;
}

.kc-panel__label {
  color: var(--effect-color, #f87171);
  text-transform: uppercase;
  font-weight: 800;
  font-size: 0.62rem;
  letter-spacing: 0.06em;
}

.kc-panel__desc {
  font-size: 0.78rem;
  line-height: 1.45;
  color: #cbd5e1;
  font-weight: 700;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/StatusTags/KcStatusPills.css"],"names":[],"mappings":"AAAA;;yDAEyD;AACzD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,iEAAiE;EACjE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kCAAkC;EAClC,qEAAqE;EACrE,qDAAqD;EACrD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,oBAAoB,aAAa,EAAE;;AAEnC;;;;;uEAKuE;AACvE;EACE,2FAA2F;AAC7F;AACA;EACE,iDAAiD;AACnD;AACA;EACE;;;;GAIC;EACD,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,gDAAgD;AAClD;;AAEA,8BAA8B,gCAAgC,EAAE;;AAEhE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iEAAiE;EACjE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,qDAAqD;EACrD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;;;+DAG+D;AAC/D;EACE;SACO,mBAAmB,EAAE;EAC5B,MAAM,qBAAqB,EAAE;EAC7B,MAAM,sBAAsB,EAAE;EAC9B,MAAM,sBAAsB,EAAE;EAC9B,MAAM,mBAAmB,EAAE;AAC7B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,yEAAyE;EACzE,qDAAqD;AACvD;;AAEA;EACE,sCAAsC,eAAe,EAAE;AACzD;;AAEA;;;;;2CAK2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA,uBAAuB,WAAW,EAAE,YAAY,EAAE;;AAElD;;+DAE+D;AAC/D,0BAA0B,2CAA2C,EAAE;AACvE,yCAAyC,+BAA+B,EAAE;AAC1E;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;;;;yDAKyD;AACzD;EACE,+CAA+C;AACjD;;AAEA,wCAAwC,+BAA+B,EAAE;;AAEzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iEAAiE;EACjE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,qDAAqD;EACrD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,mFAAmF;AACnF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;kFACkF;AAClF,kCAAkC,aAAa,EAAE;AACjD;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA,iDAAiD;AACjD;EACE,+CAA+C;AACjD;;AAEA,oCAAoC,+BAA+B,EAAE;;AAErE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6EAA6E;EAC7E,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,kCAAkC;EAClC,cAAc;AAChB;;AAEA;oEACoE;AACpE;EACE,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;EACP,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;EAC1C,wEAAwE;EACxE,UAAU;EACV,0BAA0B;EAC1B,oBAAoB;EACpB,oDAAoD;EACpD,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,UAAU;EACV,wCAAwC;AAC1C;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX","sourcesContent":["/* Authored HTN compact status grammar, shared by drug-toast previews and the\n   live combat player rail. These component-owned kc-* classes deliberately do\n   not inherit the unrelated bls-status-header chassis. */\n.kc-tag {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  outline: none;\n  cursor: help;\n  flex: 0 0 auto;\n}\n\n.kc-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 30px;\n  min-height: 30px;\n  padding: 0 9px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  color: rgba(255, 255, 255, 0.78);\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: 0.22px;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  box-sizing: border-box;\n  flex: 0 0 auto;\n}\n\n.kc-pill__icon {\n  width: 15px;\n  height: 15px;\n  flex: 0 0 15px;\n}\n\n/* Potassium: bold blue K+ glyph + green-gradient monospace readout. */\n.kc-pill--potassium {\n  border-left: 2px solid rgba(96, 165, 250, 0.55);\n}\n\n.kc-pill--potassium .kc-kglyph {\n  display: inline-flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex: 0 0 auto;\n  font-family: var(--font-display, 'Outfit', system-ui, sans-serif);\n  font-weight: 800;\n  font-size: 15px;\n  line-height: 1;\n  letter-spacing: 0.01em;\n  color: rgba(96, 165, 250, 0.95);\n}\n\n.kc-pill--potassium .kc-kglyph sup {\n  font-size: 0.58em;\n  font-weight: 800;\n  line-height: 1;\n  margin-left: 0.5px;\n  vertical-align: top;\n  position: relative;\n  top: -0.15em;\n}\n\n.kc-readout {\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: 0.01em;\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  background: linear-gradient(100deg, #86efac, #4ade80);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  -webkit-text-fill-color: transparent;\n}\n\n.kc-readout__dash { margin: 0 3px; }\n\n/* Banded potassium pill (Edward 2026-07-22): in combat the K+ status tag tints to\n   the CURRENT band's tone — the SAME --effect-color the tooltip uses (hypo blue /\n   balanced green / hyper red) — so the pill's colour matches the tooltip scheme at a\n   glance. --kc-accent is set inline to model.tone. Scoped to .kc-pill--banded so the\n   drug-toast PotassiumTag keeps its default blue-border / green-readout identity;\n   the fallbacks reproduce that default if --kc-accent is ever unset. */\n.kc-pill--potassium.kc-pill--banded {\n  border-left-color: color-mix(in srgb, var(--kc-accent, rgb(96, 165, 250)) 55%, transparent);\n}\n.kc-pill--potassium.kc-pill--banded .kc-kglyph {\n  color: var(--kc-accent, rgba(96, 165, 250, 0.95));\n}\n.kc-pill--potassium.kc-pill--banded .kc-readout {\n  background: linear-gradient(\n    100deg,\n    color-mix(in srgb, var(--kc-accent, rgb(74, 222, 128)) 62%, #ffffff),\n    var(--kc-accent, rgb(74, 222, 128))\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\n/* HR: heartbeat glyph + rose-gradient readout. */\n.kc-pill--hr {\n  border-left: 2px solid rgba(251, 113, 133, 0.55);\n}\n\n.kc-pill--hr .kc-pill__icon { color: rgba(251, 113, 133, 0.95); }\n\n.kc-pill--hr .kc-hrglyph {\n  display: inline-flex;\n  align-items: center;\n  font-family: var(--font-display, 'Outfit', system-ui, sans-serif);\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 1;\n  letter-spacing: 0.02em;\n  background: linear-gradient(100deg, #fb7185, #f43f5e);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* Heartbeat throb (Edward 2026-07-25): when the HR rail pill carries a nonzero\n   pulse shift, its glyph BEATS at a rate set inline via --hr-beat-duration\n   (tachycardia faster, bradycardia slower). A lub-dub systolic double-bump reads\n   as a real heartbeat and stands in for the numeric readout. */\n@keyframes kc-hr-beat {\n  0%,\n  100% { transform: scale(1); }\n  12% { transform: scale(1.3); }\n  24% { transform: scale(0.95); }\n  36% { transform: scale(1.13); }\n  52% { transform: scale(1); }\n}\n\n.kc-pill--hr-beating .kc-pill__icon {\n  transform-origin: center;\n  will-change: transform;\n  animation: kc-hr-beat var(--hr-beat-duration, 850ms) ease-in-out infinite;\n  filter: drop-shadow(0 0 3px rgba(251, 113, 133, 0.5));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .kc-pill--hr-beating .kc-pill__icon { animation: none; }\n}\n\n/* Pending-mechanic suffix (2026-07-28) — the clock + rounds-remaining countdown a\n   pill carries while its mechanic is drafted but not yet active. Teal\n   rgb(45,212,191) is the canonical \"this lands later\" colour, shared with the\n   delayed-damage tag, the `round`/`rounds` status word and GameTip's ClockIcon.\n   It is deliberately NOT the pill's own rose: the countdown belongs to the delay,\n   not to the mechanic waiting behind it. */\n.kc-pill__suffix {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: 1px;\n  color: rgb(45, 212, 191);\n  font-weight: 800;\n  font-size: 11px;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  font-feature-settings: \"tnum\";\n}\n\n.kc-pill__suffix svg { width: 11px; height: 11px; }\n\n/* A pulse that has not started yet does not throb and does not read rose. The\n   glyph goes slate until the round it fires, so \"armed\" and \"active\" are\n   distinguishable at a glance without reading the countdown. */\n.kc-pill--hr.is-pending { border-left-color: rgba(45, 212, 191, 0.55); }\n.kc-pill--hr.is-pending .kc-pill__icon { color: rgba(148, 163, 184, 0.9); }\n.kc-pill--hr.is-pending .kc-hrglyph {\n  background: linear-gradient(100deg, #cbd5e1, #94a3b8);\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\n/* Vasodilation (2026-07-28): blue, the colour this app already uses for \"the\n   incoming thing was negated\" (the ADR-dodge absorb chip, 96,165,250). Vasodilation\n   is exactly that primitive on the HTN board — a charge voids one whole pressure\n   application — so it joins that family rather than inventing a sixth accent. It is\n   deliberately NOT pressure's red: the tag is the answer to pressure, not a dose of\n   it, and colouring it red would read as damage taken. */\n.kc-pill--vasodilation {\n  border-left: 2px solid rgba(96, 165, 250, 0.55);\n}\n\n.kc-pill--vasodilation .kc-pill__icon { color: rgba(96, 165, 250, 0.95); }\n\n.kc-pill--vasodilation .kc-hrglyph {\n  display: inline-flex;\n  align-items: center;\n  font-family: var(--font-display, 'Outfit', system-ui, sans-serif);\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 1;\n  letter-spacing: 0.02em;\n  background: linear-gradient(100deg, #93c5fd, #60a5fa);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* The charge count. Tabular so a 3 -> 2 -> 1 countdown does not reflow the pill. */\n.kc-pill__count {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 2px;\n  padding: 0 4px;\n  border-radius: 4px;\n  background: rgba(96, 165, 250, 0.16);\n  color: rgb(147, 197, 253);\n  font-weight: 900;\n  font-size: 12px;\n  line-height: 16px;\n  font-variant-numeric: tabular-nums;\n  font-feature-settings: \"tnum\";\n}\n\n/* Spent. The pill stays on the rail rather than vanishing, because \"you had this and\n   it is gone\" is information the player needs to read the round they just lost. */\n.kc-pill--vasodilation.is-spent { opacity: 0.55; }\n.kc-pill--vasodilation.is-spent .kc-pill__count {\n  background: rgba(148, 163, 184, 0.16);\n  color: rgba(148, 163, 184, 0.95);\n}\n\n/* Diuresis: teal droplet glyph + teal readout. */\n.kc-pill--diuresis {\n  border-left: 2px solid rgba(45, 212, 191, 0.55);\n}\n\n.kc-pill--diuresis .kc-pill__icon { color: rgba(45, 212, 191, 0.95); }\n\n.kc-pill--diuresis .kc-hrglyph {\n  display: inline-flex;\n  align-items: center;\n  font-family: var(--font-primary, 'Hanken Grotesk', -apple-system, sans-serif);\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 1;\n  letter-spacing: 0.01em;\n  text-transform: capitalize;\n  font-variant-numeric: tabular-nums;\n  color: #2dd4bf;\n}\n\n/* Potassium preview hover panel. The live rail keeps its existing\n   CombatTooltip wrapper and therefore renders only PotassiumPill. */\n.kc-panel {\n  position: absolute;\n  bottom: calc(100% + 10px);\n  left: 0;\n  right: auto;\n  z-index: 1000;\n  width: max-content;\n  max-width: min(320px, calc(100vw - 24px));\n  padding: 0.72rem 0.9rem 0.72rem 1rem;\n  background: #0b0e14;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  transform: translateY(4px);\n  pointer-events: none;\n  transition: opacity 140ms ease, transform 140ms ease;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  text-align: left;\n  white-space: normal;\n}\n\n.kc-panel::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 2px;\n  background: var(--effect-color, #f87171);\n}\n\n.kc-tag:hover .kc-panel,\n.kc-tag:focus-within .kc-panel {\n  opacity: 1;\n  transform: none;\n  pointer-events: auto;\n}\n\n.kc-panel__label {\n  color: var(--effect-color, #f87171);\n  text-transform: uppercase;\n  font-weight: 800;\n  font-size: 0.62rem;\n  letter-spacing: 0.06em;\n}\n\n.kc-panel__desc {\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: #cbd5e1;\n  font-weight: 700;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
